export const DELIVERY_AREAS = [
  { name: '岳塘区', isCore: true, maxDistance: 10 },
  { name: '雨湖区', isCore: true, maxDistance: 10 },
  { name: '湘潭县', isCore: false, maxDistance: 15 },
  { name: '湘乡市', isCore: false, maxDistance: 20 },
  { name: '韶山市', isCore: false, maxDistance: 20 },
]

export const DELIVERY_TIME_SLOTS = [
  '09:00-10:00', '10:00-11:00', '11:00-12:00', '12:00-13:00',
  '13:00-14:00', '14:00-15:00', '15:00-16:00', '16:00-17:00',
  '17:00-18:00', '18:00-19:00', '19:00-20:00', '20:00-21:00',
]

export const MEMBER_LEVELS = [
  { level: 1, name: '普通会员', discount: 0.95, growthNeeded: 0, color: '#6B7280' },
  { level: 2, name: '银卡会员', discount: 0.9, growthNeeded: 1000, color: '#9CA3AF' },
  { level: 3, name: '金卡会员', discount: 0.85, growthNeeded: 5000, color: '#F59E0B' },
  { level: 4, name: '钻石会员', discount: 0.8, growthNeeded: 10000, color: '#8B5CF6' },
]

export const CAKE_CATEGORIES = ['生日蛋糕', '情人节蛋糕', '儿童节蛋糕', '企业定制', '下午茶']
export const CAKE_STYLES = ['ins风', '复古风', '新中式', '极简风', '卡通风']
export const CAKE_TASTES = ['巧克力味', '水果味', '芝士味', '抹茶味', '榴莲味', '原味']

export const CAKE_SIZES = [
  { name: '6寸', priceMultiplier: 1, description: '适合1-2人' },
  { name: '8寸', priceMultiplier: 1.5, description: '适合3-5人' },
  { name: '10寸', priceMultiplier: 2, description: '适合6-8人' },
  { name: '12寸', priceMultiplier: 2.5, description: '适合9-12人' },
]

export const SUGAR_OPTIONS = ['无糖', '低糖', '半糖', '正常糖', '高糖']
export const INTERLAYER_OPTIONS = ['原味奶油', '水果夹层', '巧克力夹层', '芋泥夹层', '豆沙夹层']
export const DECORATION_OPTIONS = ['鲜花', '水果', '巧克力牌', '蜡烛', '翻糖装饰', '奶油裱花']

// 积分汇率：100积分 = 1元
export const POINTS_EXCHANGE_RATE = 100

// 审核状态
export const AUDIT_STATUS = {
  NONE: 0,        // 无需审核
  PENDING: 1,     // 待审核
  APPROVED: 2,    // 审核通过
  REJECTED: 3,    // 审核拒绝
} as const

export const AUDIT_STATUS_LABELS: Record<number, string> = {
  0: '无需审核',
  1: '待审核',
  2: '审核通过',
  3: '审核拒绝',
}

// 签到规则
export const CHECKIN_RULES = [
  { day: 1, points: 5 },
  { day: 2, points: 10 },
  { day: 3, points: 15 },
  { day: 4, points: 20 },
  { day: 5, points: 25 },
  { day: 6, points: 30 },
  { day: 7, points: 50 },  // 第7天大奖励
] as const

// 管理员角色及权限
export const ADMIN_ROLES = [
  { role: '超级管理员', label: '超级管理员', color: '#8B5CF6', permissions: ['overview', 'orders', 'products', 'pointOrders', 'accounts'] },
  { role: '管理员',     label: '管理员',     color: '#3B82F6', permissions: ['overview', 'orders', 'products', 'pointOrders'] },
  { role: '店长',       label: '店长',       color: '#F59E0B', permissions: ['overview', 'orders', 'pointOrders'] },
  { role: '店员',       label: '店员',       color: '#6B7280', permissions: ['orders'] },
] as const
